import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  className?: string;
  linkToHome?: boolean;
  variant?: 'default' | 'white' | 'bright';
}

export function Logo({
  className = '',
  linkToHome = false,
  variant = 'default',
}: LogoProps) {
  const src =
    variant === 'white'
      ? '/logo-text-white.svg'
      : variant === 'bright'
        ? '/logo-text-bright.svg'
        : '/logo-text.svg';
  const logoElement = (
    <Image
      src={src}
      alt="GetFacade"
      width={164}
      height={24}
      priority
      className={className}
      style={{ height: 'auto' }}
    />
  );

  if (linkToHome) {
    return (
      <Link href="/" className="inline-block">
        {logoElement}
      </Link>
    );
  }

  return logoElement;
}
